module.exports = __webpack_public_path__ + "static/lightning-notification-0fd31d502ab0c2453ae4d8c14740ba17.png";